interface CloudWithCircuitsSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CloudWithCircuitsSVG = ({ color, style }: CloudWithCircuitsSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="49"
    viewBox="0 0 49 49"
    fill="none"
  >
    <g clipPath="url(#clip0_955_12407)">
      <path
        d="M24.4999 27.4866V42.5168"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M27.4867 45.5035C27.4867 47.1523 26.1488 48.4902 24.5 48.4902C22.8512 48.4902 21.5133 47.1523 21.5133 45.5035C21.5133 43.8547 22.8512 42.5168 24.5 42.5168C26.1488 42.5168 27.4867 43.8547 27.4867 45.5035Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.5532 42.5168V36.4466L18.5266 33.4599V27.4866"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M15.5399 45.5035C15.5399 47.1523 14.2046 48.4902 12.5532 48.4902C10.9019 48.4902 9.56909 47.1523 9.56909 45.5035C9.56909 43.8547 10.9044 42.5168 12.5532 42.5168C14.202 42.5168 15.5399 43.8547 15.5399 45.5035Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M36.4466 42.5168V36.4466L30.4733 33.4599V27.4866"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M42.4022 12.6042C42.4048 12.5532 42.4175 12.5048 42.4175 12.4538C42.4175 7.5151 38.3988 3.49633 33.46 3.49633C31.429 3.49633 29.5763 4.19968 28.0728 5.34135C25.8965 2.42347 22.4485 0.509644 18.5266 0.509644C11.9289 0.509644 6.48302 5.85867 6.48302 12.4538C6.48302 12.5048 6.49576 12.5532 6.49831 12.6042C3.08349 13.2897 0.509644 16.4038 0.509644 20.0199C0.509644 24.1432 3.8531 27.4867 7.97636 27.4867H40.9242C45.0474 27.4867 48.4903 24.1432 48.4903 20.0199C48.4903 16.4038 45.8171 13.2897 42.4022 12.6042Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.46 45.5035C33.46 47.1523 34.7953 48.4902 36.4466 48.4902C38.098 48.4902 39.4308 47.1523 39.4308 45.5035C39.4308 43.8547 38.0954 42.5168 36.4466 42.5168C34.7979 42.5168 33.46 43.8547 33.46 45.5035Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_955_12407">
        <rect width="49" height="49" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default CloudWithCircuitsSVG;
